/* eslint-disable jsx-a11y/label-has-for */
import React, { useState } from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SettingsModal = ({
  open,
  appliedStart,
  appliedEnd,
  onClose,
  onApplySettings
}) => {
  const [start, setStart] = useState(appliedStart);
  const [end, setEnd] = useState(appliedEnd);
  const [errorText, setErrorText] = useState(null);
  const [defaultDates, setDefaultDates] = useState(false);

  const updateInput = func => e => {
    if (errorText) {
      setErrorText(null);
    }

    func(e.target.value);
  };

  const onSetDefault = () => {
    localStorage.setItem('defaultTrackerDates', `${start},${end}`);
  };

  const onApply = () => {
    if (parseInt(end) - parseInt(start) > 500) {
      setErrorText('Range is too large. Please select different dates.');
      return;
    } else if (parseInt(start) > parseInt(end)) {
      setErrorText(
        'Start date is greater than end date. Plese select different dates.'
      );
      return;
    }

    if (defaultDates) {
      onSetDefault();
    }
    onApplySettings([start, end]);
    onClose();
  };

  const onClickDefaultDates = () => {
    setDefaultDates(!defaultDates);
  };

  const disableApply = () =>
    Number(start) === Number(appliedStart) &&
    Number(end) === Number(appliedEnd);

  return (
    <Modal
      className="tvt-anticipation-tracker-modal"
      show={open}
      onHide={onClose}
      backdrop
    >
      <div className="tvt-anticipation-tracker__modal-header">
        Follower Growth Chart Settings
      </div>
      <div className="tvt-anticipation-tracker__modal-input-wrapper">
        <div>
          Days from Release:{' '}
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="tvt-anticipation-tracker__item-tooltip">
                <div>
                  The input fields allow you to create a custom range for the
                  Days From Release axis. Negative values represent days before
                  release. Positive numbers represent days after release.
                </div>
              </Tooltip>
            }
          >
            <FontAwesomeIcon
              className="benchmark-info-icon"
              size="1x"
              icon="info-circle"
            />
          </OverlayTrigger>
        </div>
        <div className="tvt-anticipation-tracker__modal-input-start">
          <span>START</span>{' '}
          <input type="number" onChange={updateInput(setStart)} value={start} />
        </div>
        <FontAwesomeIcon
          className="tvt-anticipation-trackker__arrow-right-icon"
          icon="arrow-right"
          size="1x"
        />
        <div>
          <input type="number" onChange={updateInput(setEnd)} value={end} />{' '}
          <span>END</span>
        </div>
      </div>
      {errorText && (
        <div className="tvt-anticipation-tracker__modal-error-text">
          {errorText}
        </div>
      )}
      <div className="tvt-anticipation-tracker__modal-footer">
        <label className="tvt-benchmark__default-checkbox">
          Set Range as Default{' '}
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="tvt-anticipation-tracker__item-tooltip">
                <div>
                  When selected, axis will be automatically set for any future
                  queries
                </div>
              </Tooltip>
            }
          >
            <FontAwesomeIcon
              className="benchmark-info-icon"
              size="1x"
              icon="info-circle"
            />
          </OverlayTrigger>
          <input
            id="tvt-benchmark__default-checkbox-input"
            type="checkbox"
            defaultChecked={defaultDates}
            onChange={onClickDefaultDates}
          />
          <span className="checkmark" />
        </label>
        <button
          disabled={disableApply()}
          onClick={onApply}
          className="tvt-reactions__button-apply"
        >
          APPLY
        </button>
        <button onClick={onClose} className="tvt-reactions__button-cancel">
          CANCEL
        </button>
      </div>
    </Modal>
  );
};

SettingsModal.propTypes = {
  onApply: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  showTable: PropTypes.bool.isRequired,
  openSegment: PropTypes.func.isRequired
};
export default SettingsModal;
